import type {
    TransportRequestCrudContextLike,
    TransportRequestFormContextLike,
    TransportRequestPermissions,
    TransportRequestRelationRef,
    TransportRequestStatusRef,
} from '@/Containers/TransportationSection/Components'
import type { UserLike } from '@/Ship/Helpers/fieldViews'

/** Ключ ресурсу тендера — під ним його відкривають реєстр, канбан, пошук і вкладка клієнта. */
export const TENDER_RESOURCE = 'Transportation.Tender'

/** Колекція тендерів (`SPEC-022` §6). */
export const TENDER_REST_URL = '/services/tenders'

/** Крок 1 двокрокового завантаження файлу тендера (`SPEC-022` §4.4). */
export const TENDER_FILE_UPLOAD_URL = '/services/tender_files'

/** Довідник статусів тендерів (`SPEC-007`): рядок статусів, колонки канбану, бейджі підказки. */
export const TENDER_STATUS_RESOURCE = 'Setting.ListTenderStatus'

/** Довідник причин програшу тендерів — варіанти модалки «Програти». */
export const TENDER_LOSS_REASON_RESOURCE = 'Setting.ListTenderLossReason'

/** Ширина шухляди картки — як у картки клієнта (два стовпці блоків). */
export const TENDER_DRAWER_WIDTH = 1200

/** Системні коди статусів тендера (`TenderStatusCode` беку). */
export const TENDER_STATUS_CODES = {
    new: 'tender-new',
    price: 'tender-price',
    application: 'tender-application',
    loss: 'tender-loss',
} as const

/** Запис тендера так, як його віддають картка й колекція (лише те, що читає фронт). */
export interface TenderRecord {
    uuid?: string
    '@id'?: string
    id?: number
    title?: string
    client?: TransportRequestRelationRef | null
    status?: TransportRequestStatusRef | null
    responsible?: UserLike | null
    loadingCountries?: TransportRequestRelationRef[] | null
    unloadingCountries?: TransportRequestRelationRef[] | null
    typesCars?: TransportRequestRelationRef[] | null
    /** Крайній термін — дата без часу (`SPEC-023` §4.1) */
    deadline?: string | null
    cargo?: string | null
    offeredPrice?: number | null
    closingAt?: string | null
    lossReason?: TransportRequestRelationRef | null
    createdAt?: string | null
    countOffers?: number | null
    _permissions?: TransportRequestPermissions
}

/** Відповідь колекції `GET /services/tenders`. */
export interface TenderCollectionResponse {
    items?: TenderRecord[]
    meta?: { total?: number }
}

export type TenderFormContextLike = TransportRequestFormContextLike
export type TenderCrudContextLike = TransportRequestCrudContextLike
